import {AuditService} from "../PA.Core/Security/AuditService";
import {AuditLogType} from "../PA.Core/PA.Core.IF.Audit";
import {TPMPlanBO} from "./TPMPlanBO";

export class TPMPlanBOAudit {

    /**
     * Audit Log for accept adjusted baseline
     * @param TPMPlanBO
     * @param oldPlan
     * @return Promise<AuditService>
     */
    static async AcceptAdjBaseTPMPlanAuditBO(TPMPlanBO: TPMPlanBO, totalUnits: string): Promise<AuditService> {
        const self = TPMPlanBO;
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("TPMPlan", self.drWB_Plan.cif.WB_PLAN_ID)

        auditService.LogSync(AuditLogType.BaselineAccepted, `Total Units: ` + totalUnits)

        return auditService;

    }
}
